<template>
  <div class="iteminventario">
    <router-link :to="'inventario/' + obj.codigo">
      <div class="inventario-item" v-bind:class="corStatusComputado">
        <b style="font-size: 1.1em">{{ obj.nome }}</b><br />
        {{ obj.codigo }}<br />
        {{ statusText }}<br />
      </div>
    </router-link>
  </div>
</template>

<script>
function compararDataInicio (a, b) {
  if (!a.inicio || !b.inicio || new Date(a.inicio.seconds * 1000) > new Date(b.inicio.seconds * 1000)) return 1
  if (new Date(a.inicio.seconds * 1000) < new Date(b.inicio.seconds * 1000)) return -1
  return 0
}

function computarStatus (obj) {
  if (!obj.ativo) {
    return 'desativado'
  }
  const dataAtual = new Date()
  const lastCheck = new Date(obj.local[obj.local.length - 1].data.seconds * 1000)
  const usos = []
  for (let i = 0; i < obj.usos.length; i++) {
    usos.push(obj.usos[i])
  }
  usos.sort(compararDataInicio)
  // Vetor usos está sortado por data de inicio
  for (let i = 0; i < usos.length; i++) {
    if (dataAtual > new Date(usos[i].inicio.seconds * 1000) && dataAtual < new Date(usos[i].termino.seconds * 1000)) {
      return 'em uso'
    }
    if (i < usos.length - 1 && dataAtual > new Date(usos[i].termino.seconds * 1000) && dataAtual < new Date(usos[i + 1].inicio.seconds * 1000)) {
      if (lastCheck < new Date(usos[i].termino.seconds * 1000)) {
        return 'requer verificacao e uso agendado'
      } else {
        return 'uso agendado'
      }
    }
    if (usos.length === 1 && dataAtual < new Date(usos[i].inicio.seconds * 1000)) {
      return 'uso agendado'
    }
    if (i === usos.length - 1 && dataAtual > new Date(usos[i].termino.seconds * 1000) && lastCheck < new Date(usos[i].termino.seconds * 1000)) {
      return 'requer verificacao'
    }
  }
  return 'situacao regular'
}

export default {
  name: 'ItemInventario',
  props: {
    obj: Object
  },
  computed: {
    corStatusComputado: function () {
      return {
        orange: computarStatus(this.obj) === 'requer verificacao',
        red: computarStatus(this.obj) === 'requer verificacao e uso agendado',
        lightgray: computarStatus(this.obj) === 'desativado',
        gray: computarStatus(this.obj) === 'situacao regular',
        yellow: computarStatus(this.obj) === 'em uso'
      }
    },
    statusText: function () {
      if (computarStatus(this.obj) === 'requer verificacao') return 'Requer verificação'
      if (computarStatus(this.obj) === 'requer verificacao e uso agendado') return 'Requer verificação. Uso agendado!'
      if (computarStatus(this.obj) === 'desativado') return 'Desativado'
      if (computarStatus(this.obj) === 'em uso') return 'Em uso'
      if (computarStatus(this.obj) === 'situacao regular') return 'Situação regular'
      if (computarStatus(this.obj) === 'uso agendado') return 'Uso agendado'
      return 'Status desconhecido'
    }
  }
}
</script>

<style scoped>
a {
  color: inherit; /* blue colors for links too */
  text-decoration: inherit; /* no underline */
}

.inventario-item {
  color: white;
  padding: 10px;
  margin-top: 10px;
  background: rgb(26,87,213);
  background: linear-gradient(0deg, rgba(26,87,213,1) 0%, rgba(48,130,204,1) 100%);
  border-radius:6px;
  -moz-border-radius:6px;
  -webkit-border-radius:6px;
}

.yellow {
  background: rgb(175, 139, 22);
  background: linear-gradient(0deg, rgb(175, 139, 22) 0%, rgb(199, 167, 61) 100%);
}

.lightgray {
  background: rgb(134, 134, 134);
  background: linear-gradient(0deg, rgb(134, 134, 134) 0%, rgb(146, 146, 146) 100%);
}

.gray {
  background: rgb(64, 64, 64);
  background: linear-gradient(0deg, rgb(64, 64, 64) 0%, rgb(100, 100, 100) 100%);
}

.orange {
  background: rgb(207, 124, 0);
  background: linear-gradient(0deg, rgb(207, 124, 0) 0%, rgb(209, 142, 41) 100%);
}

.red {
  background: rgb(165, 29, 29);
  background: linear-gradient(0deg, rgb(165, 29, 29) 0%, rgb(170, 56, 56) 100%);
}
</style>
